/*
 * RosterHeaderActions — the trio of controls in the Shifts page header:
 * weeks toggle (1 wk / 2 wk / 1 mo), Fullscreen button, and the New Shift
 * primary action. Extracted so both the fullscreen and default renders
 * in Shifts.jsx share the same markup.
 */
import { Maximize2, Plus } from "lucide-react";
import { ActionButton, GhostButton } from "../Primitives";

const WEEKS_OPTIONS = [
  { v: 1, label: "1 Wk" },
  { v: 2, label: "2 Wk" },
  { v: 4, label: "1 Mo" },
];

export function RosterHeaderActions({
  weeks,
  onWeeksChange,
  onFullscreen,
  onNewShift,
  showFullscreen = true,
  showNewShift = true,
}) {
  return (
    <div className="flex gap-2">
      <div className="inline-flex border border-[#27272A]" data-testid="weeks-toggle">
        {WEEKS_OPTIONS.map((opt) => (
          <button
            key={opt.v}
            data-testid={`weeks-${opt.v}`}
            onClick={() => onWeeksChange(opt.v)}
            className={`px-3 py-2 text-xs uppercase tracking-widest transition-colors duration-150 ${
              weeks === opt.v ? "bg-[#FF3B30] text-white" : "text-zinc-400 hover:text-white"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {showFullscreen && (
        <GhostButton data-testid="open-fullscreen-button" onClick={onFullscreen} title="Open in fullscreen tab">
          <Maximize2 className="size-3.5" /> Fullscreen
        </GhostButton>
      )}
      {showNewShift && (
        <ActionButton data-testid="add-shift-button" onClick={onNewShift}>
          <Plus className="size-4" /> New Shift
        </ActionButton>
      )}
    </div>
  );
}
